export class GlobalStatusBase {
  public id: number;
  public code?: string;
  public description?: string;
  public color?: string;
  public displayOrder: number;
}
